import styled, { css, keyframes } from 'styled-components';

import media from '../../../theme/media';
import promoMedia from '../../../theme/promoMedia';

export const getoutAnimation = keyframes`
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(90vh);
    }
`;

export const Overlay = styled.div`
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    bottom: 0;
    display: block;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10000;
`;

export const PopupOuter = styled.div`
    align-items: flex-end;
    display: flex;
    justify-content: center;
    height: 100%;
    padding: ${(props) => (props.fullwidthPopup ? '0' : '0 8px')};

    ${media.tablet720} {
        align-items: center;
        padding: ${(props) => (props.fullwidthPopup ? '0 24px' : '0 8px')};
    }
`;

export const PopupBox = styled.div`
    animation-name: ${(props) => (props.animated ? getoutAnimation : '')};
    animation-duration: 0.6s;
    animation-delay: 0.1s;
    animation-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
    animation-iteration-count: 1;
    background-color: ${(props) => props.theme.white};
    border-radius: ${(props) => (props.fullwidthPopup ? '0' : '12px')};
    overflow: hidden;
    bottom: ${(props) => (props.bottom ? props.bottom : props.fullwidthPopup ? '0' : '24px')};
    max-width: ${(props) => (props.fullwidthPopup ? '888px' : '568px')};
    position: relative;
    width: 100%;

    ${media.tablet720} {
        bottom: auto;
        border-radius: 16px;
    }

    ${media.tablet1080} {
        border-radius: ${(props) => (props.fullwidthPopup ? '12px' : null)};
    }

    ${promoMedia.desktop1440} {
        border-radius: 12px;
    }
`;

export const PopupBoxInner = styled.div`
    max-height: ${(props) => (props.fullwidthPopup ? '100vh' : 'calc(100vh - 150px)')};
    overflow-y: ${(props) => (props.isShowSpinner ? 'hidden' : 'auto')};
    position: relative;

    ${media.tablet720} {
        max-height: calc(100vh - 96px);
    }
`;

export const PopupBoxClose = styled.div`
    position: absolute;
    top: 24px;
    right: 24px;
`;

/* Popup Button */
const getHoveredBackground = (props) => {
    if (props.disabled) {
        return 'none';
    } else {
        return props.isAlertButton ? props.theme.pink_8_tr : props.theme.purple_8_tr;
    }
};

const ButtonCommonCss = css`
    padding: 20px 24px;
    align-items: center;
    display: flex;
    cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
    width: 100%;
    font-family: inherit;
    border: none;
    box-sizing: border-box;
    outline: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
    pointer-events: auto;
    font-size: 17px;
    line-height: 24px;
    background: none;
    justify-content: ${(props) => (props.isCentered ? 'center' : null)};

    &:active,
    &:hover:not(:focus) {
        background: ${(props) => getHoveredBackground(props)};
    }

    ${media.tablet720} {
        padding: 28px 32px;
        font-size: 20px;
        line-height: 32px;
    }
`;

export const CommonButton = styled.a`
    ${ButtonCommonCss}
`;

export const SubmitButton = styled.button`
    ${ButtonCommonCss}
`;

export const IconWrap = styled.span`
    margin-right: 24px;
    height: 24px;
`;

export const DiskBadgeWrap = styled.span`
    margin-right: 16px;
`;

/* Simple Popup */
export const PopupContent = styled.div`
    font-size: 17px;
    line-height: 24px;
    padding: 72px 0 24px 0;

    ${media.tablet720} {
        font-size: 20px;
        line-height: 32px;
        padding: 88px 0 44px 0;
    }
`;

export const PopupHeader = styled.div`
    padding: 0 32px 48px 32px;
    text-align: ${(props) => (props.textAlign ? props.textAlign : 'center')};

    /* в простых попапах может быть несколько строк текста, используем тег p */

    p {
        margin-top: 0;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .violetLink {
        color: ${(props) => props.theme.purple_100};
    }
`;

/* Попапы с кнопками и текстом имеют разделитель, попапы без текста - нет (withoutBorder) */
export const PopupButtons = styled.div`
    padding-top: ${(props) => (props.withoutBorder ? '0' : '24px')};
    border-top: ${(props) => (props.withoutBorder ? 'none' : `1px solid ${props.theme.grey_28_tr}`)};

    ${media.tablet720} {
        padding-top: ${(props) => (props.withoutBorder ? '0' : '32px')};
    }
`;

/* Complex Popup */
export const PopupBody = styled.div`
    padding: ${(props) => (props.hasPseudoTable ? '32px 24px 96px 24px' : props.hasBottomPanel ? '72px 24px 96px 24px' : '72px 24px 24px 24px')};
    font-size: 17px;
    line-height: 24px;
    color: ${(props) => props.theme.black};
    text-align: ${(props) => (props.textCenter ? 'center' : '')};

    ${media.tablet720} {
        padding-top: ${(props) => (props.hasPseudoTable ? '48px' : '88px')};
        padding-left: ${(props) => (props.hasPseudoTable ? '48px' : '32px')};
        padding-right: ${(props) => (props.hasPseudoTable ? '48px' : '32px')};
        padding-bottom: ${(props) => (props.hasBottomPanel ? '96px' : '48px')};
        font-size: 20px;
        line-height: 32px;
    }
`;

export const ComplexButtonPanel = styled.div`
    display: flex;
    justify-content: center;
    position: -webkit-sticky;
    position: sticky;
    bottom: 24px;
    margin-top: 32px;
    z-index: 1;

    ${media.tablet720} {
        bottom: 48px;
        margin-top: 48px;
    }
`;

export const ComplexPopupRow = styled.div`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }

    ${media.tablet720} {
        margin-bottom: 48px;
    }
`;

export const SecondaryButton = styled.div`
    margin-right: 24px;
`;
